import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { createAsyncMetaSelectors, createScopedSelector } from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { resourcesKey } from '../../reducers';
import { parentSelector } from './parentSelector';

const getResourcesState = createSelector(parentSelector, get(resourcesKey));
const getResourcesScope = createScopedSelector({
    parentSelector: getResourcesState,
    initialState: META_STATE_SUCCEEDED,
});

const getResourcesMeta = createSelector(getResourcesScope, get('meta'));

export const [areResourcesFetching, haveResourcesFailed] = createAsyncMetaSelectors(getResourcesMeta);
